import axios from "axios";

const inovaone_api = axios.create({
  // baseURL: "http://localhost:8000/",
  // baseURL: "https://api.inovacode.app.br/",
  // baseURL: "https://apione.inovacode.app.br",
  baseURL: "https://api-impressao.inovacode.app.br/",
});

// Autenticação lida do localStorage a cada requisição.
//
// Antes o token só entrava em inovaone_api.defaults, no login e no efeito do
// UsuarioProvider. No refresh de página isso abre uma janela: os efeitos dos
// componentes filhos rodam antes do efeito do provider, então a primeira
// requisição da tela saía sem Authorization, a API respondia 401 e o
// interceptor de resposta abaixo derrubava o usuário para o login.
inovaone_api.interceptors.request.use((config) => {
  const access_token = localStorage.getItem("access_token");
  if (access_token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${access_token}`;
  }

  if (!config.headers["id_conta"]) {
    const usuario_local_info = localStorage.getItem("usuario_local_info");
    if (usuario_local_info) {
      try {
        const { id_conta } = JSON.parse(usuario_local_info);
        if (id_conta) config.headers["id_conta"] = id_conta;
      } catch {
        // informação corrompida no storage: segue sem o cabeçalho
      }
    }
  }

  return config;
});

inovaone_api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Os fluxos de MFA usam status 401 (login pede o código, código inválido,
    // ativar/desativar). Não devemos deslogar nesses casos - eles são tratados
    // localmente. Identificamos pelo flag mfaRequired ou pela rota de MFA.
    const url: string = error.config?.url || "";
    const isMfaChallenge =
      error.response?.data?.mfaRequired === true ||
      url.includes("/usuario/mfa/");

    if (error.response && error.response.status === 401 && !isMfaChallenge) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("usuario_local_info");
      document.location.href = "/auth";
    }
    return Promise.reject(error);
  },
);

export default inovaone_api;
